import { SEARCH_FACET_FILTERS } from '@edx/frontend-enterprise-catalog-search';
import { features } from '../../config';

export const NUM_RESULTS_PER_PAGE = 24;
export const CONTENT_TYPE_COURSE = 'course';
export const CONTENT_TYPE_PROGRAM = 'program';
export const CONTENT_TYPE_PATHWAY = 'learnerpathway';
export const CONTENT_TYPE_VIDEO = 'video';
export const NUM_RESULTS_PROGRAM = 4;
export const NUM_RESULTS_PATHWAY = 4;
export const NUM_RESULTS_ACADEMY = 4;
export const NUM_RESULTS_COURSE = 20;
export const NUM_RESULTS_VIDEO = 20;
export const COURSE_TITLE = 'Courses';
export const PROGRAM_TITLE = 'Programs';
export const PATHWAY_TITLE = 'Pathways';
export const ACADEMY_TITLE = 'Academies';
export const VIDEO_TITLE = 'Videos';
export const HEADER_TITLE = 'Search Courses and Programs';
export const SEARCH_TRACKING_NAME = 'learner_portal';

const OVERRIDE_FACET_FILTERS = [];
if (features.PROGRAM_TYPE_FACET) {
  const PROGRAM_TYPE_FACET_OVERRIDE = {
    overrideSearchKey: 'title',
    overrideSearchValue: 'Program',
    updatedFacetFilterValue: {
      attribute: 'program_type',
      title: 'Program',
      isSortedAlphabetical: true,
      typeaheadOptions: {
        placeholder: 'Find a program...',
        ariaLabel: 'Type to find a program',
        minLength: 3,
      },
    },
  };
  OVERRIDE_FACET_FILTERS.push(PROGRAM_TYPE_FACET_OVERRIDE);
}

OVERRIDE_FACET_FILTERS.forEach(({ overrideSearchKey, overrideSearchValue, updatedFacetFilterValue }) => {
  SEARCH_FACET_FILTERS.find((facetFilter, index) => {
    if (facetFilter[overrideSearchKey] === overrideSearchValue) {
      SEARCH_FACET_FILTERS[index] = updatedFacetFilterValue;
      return true;
    }
    return false;
  });
});

export const CARDGRID_COLUMN_SIZES = {
  xs: 12,
  md: 6,
  lg: 4,
  xl: 3,
};

export { SEARCH_FACET_FILTERS };
